import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-box-wide__segment-center" }
const _hoisted_2 = {
  key: 0,
  class: "product-box-wide__highlight-article-badge"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = { class: "product-box-wide__header-text product-box__header-text" }
const _hoisted_7 = {
  key: 0,
  class: "product-box-wide__vintage product-box__vintage"
}
const _hoisted_8 = { class: "product-box-wide__name product-box__name" }
const _hoisted_9 = {
  key: 1,
  class: "product-box-wide__sub-name product-box__name"
}
const _hoisted_10 = {
  key: 2,
  class: "product-box-wide__sub-name product-box__name"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]

import type ProductBoxData from '../../../bps/types/ProductBoxData';
  import useHighlightArticle from '@/bps/utilities/composables/productHighlightArticle';
  import {computed, inject} from 'vue';
  import {t} from '@/bps/utilities/js/translations/translations';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductBoxWideSegmentCenter',
  props: {
    descriptionExcerpt: {},
    minimumRating: {},
    basketUrl: {},
    productBoxData: {}
  },
  setup(__props: any) {

  const props = __props;

  const linkTarget = inject('productBoxLinkTarget', null);

  const {highlightArticleData} = useHighlightArticle(props.productBoxData.highlightArticleId);

  const highlightBadgeData = computed(() => {
    const textSpacer = '&nbsp;&nbsp;';

    if (highlightArticleData.value) {
      const articleHighlight = highlightArticleData.value;
      articleHighlight.text += textSpacer;
      return articleHighlight;
    }

    if (props.productBoxData.personalPreferenceMessageKey) {
      return {
        style: {},
        text: t(props.productBoxData.personalPreferenceMessageKey) + textSpacer,
        icon: null
      };
    }

    return null;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (highlightBadgeData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (highlightBadgeData.value.text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: highlightBadgeData.value.text,
                class: "product-box-wide__highlight-article-text"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (highlightBadgeData.value.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "product-box-wide__highlight-article-icon",
                src: highlightBadgeData.value.icon,
                alt: "",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("a", {
      class: "product-box-wide__header product-box__segment-header",
      href: _ctx.productBoxData.url,
      target: _unref(linkTarget)
    }, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.productBoxData.vintage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.productBoxData.vintage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.productBoxData.description1), 1 /* TEXT */),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (_ctx.productBoxData.description2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.productBoxData.description2), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[3] || (_cache[3] = _createTextVNode()),
        (_ctx.productBoxData.description3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.productBoxData.description3), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        (_ctx.productBoxData.shortDescription)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: "product-box-wide__short-description product-box__short-description",
              innerHTML: _ctx.productBoxData.shortDescription
            }, null, 8 /* PROPS */, _hoisted_11))
          : _createCommentVNode("v-if", true)
      ])
    ], 8 /* PROPS */, _hoisted_5),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", {
      class: "product-box-wide__long-description",
      innerHTML: _ctx.descriptionExcerpt
    }, null, 8 /* PROPS */, _hoisted_12)
  ]))
}
}

})